<div class="flex flex-col items-center justify-center min-h-[calc(100vh-200px)] p-4">
  <div class="w-full max-w-md text-center">
    <div class="bg-white shadow-md rounded-lg p-8 space-y-6">
      <div class="mb-4">
        <h2 class="text-2xl font-semibold text-gray-800">Welcome to</h2>
        <h2 class="text-2xl font-semibold text-gray-800">Timesheet Client</h2>
        <p class="text-gray-600 mt-2">Sign in to access your account</p>
      </div>

      <button mat-raised-button color="primary" (click)="loginRedirect()" class="w-full">
        <div class="w-full flex flex-row flex-nowrap items-center justify-center items-center space-x-3 py-3">
          <img ngSrc="assets/microsoft-logo.svg" alt="Microsoft Logo" class="w-6 h-6" height="16" width="16" />
          <span>Sign in with Microsoft</span>
        </div>
      </button>

      <div class="text-xs text-gray-500 mt-4">Secure authentication powered by Microsoft</div>
    </div>
  </div>
</div>
